import { ExpandButton } from 'mol-ui';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    ButtonDiv,
    Content
} from './styled';
import {
    ListingItem,
    ListingLayout
} from 'views/components';
import React, { useEffect } from 'react';
import {
    getUserList,
    setUserSelected
} from 'core/User';
import {
    useDispatch,
    useSelector
} from 'hooks';

const UserListing = () => {

    const dispatch = useDispatch();
    const { listingUser } = useTheme();
    const { push } = useHistory();
    const { t } = useTranslation();
    const {
        user
    } = useSelector('account');
    const {
        list: usersList,
        loading
    } = useSelector('user');
    const isRestricted = !!user?.restricted_access;

    useEffect(() => {
        dispatch(getUserList());
    }, []);

    const handleSelection = user => mode => {
        const { id } = user;
        dispatch(setUserSelected({}));
        push(`${ t('/usuarios') }/${ mode === 'ver' ? `${ t('ver') }` : t('editar') }/${ id }`);
    };

    return (
        <ListingLayout loading={ loading } onFilterChange={ ({ search }) => dispatch(getUserList({ search })) }>
            <Content>
                {
                    usersList
                        ? usersList.map(user => {
                            const {
                                avatar,
                                avatar_thumbnail,
                                first_name,
                                id, identification,
                                last_name,
                                restricted_access
                            } = user;
                            return (
                                <ListingItem
                                    allowEdit={ !isRestricted }
                                    avatar={ avatar_thumbnail?.url ?? avatar?.url }
                                    color={ listingUser }
                                    icon="face"
                                    key={ id }
                                    text={ `${ identification }${ !!restricted_access ? ` (${ t('Restringido') })` : '' }` }
                                    title={ `${ last_name }, ${ first_name }` }
                                    onActionClick={ handleSelection(user) }
                                />
                            );
                        })
                        : <div>{ t('No hay usuarios para mostrar') }</div> }
            </Content>
            <ButtonDiv>
                <ExpandButton
                    caption={ t('Nuevo usuario') }
                    size={ 120 }
                    onClick={ () => push(t('/usuarios/crear')) }
                />
            </ButtonDiv>
        </ListingLayout>
    );
};

export default UserListing;
